var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackVn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99989 0C3.58876 0 0 3.5888 0 7.99999C0 12.4112 3.58876 16 7.99989 16C12.411 16 15.9998 12.4112 15.9998 7.99999C15.9998 3.5888 12.4111 0 7.99989 0Z",
    fill: "#FF1456"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32409 7.13512C5.80174 7.13512 6.18896 6.7479 6.18896 6.27024C6.18896 5.79258 5.80174 5.40536 5.32409 5.40536C4.84644 5.40536 4.45923 5.79258 4.45923 6.27024C4.45923 6.7479 4.84644 7.13512 5.32409 7.13512Z",
    fill: "#413E34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6754 7.13512C11.1531 7.13512 11.5403 6.7479 11.5403 6.27024C11.5403 5.79258 11.1531 5.40536 10.6754 5.40536C10.1978 5.40536 9.81055 5.79258 9.81055 6.27024C9.81055 6.7479 10.1978 7.13512 10.6754 7.13512Z",
    fill: "#413E34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5809 10.9614C11.6473 11.079 11.7084 11.2013 11.7627 11.3248L12.5545 10.9769C12.4886 10.8272 12.4145 10.6789 12.3342 10.5365C11.4141 8.90465 9.6095 7.91259 7.73885 8.00978C5.88031 8.10594 4.19491 9.2706 3.44507 10.9769L4.23685 11.325C4.85637 9.91521 6.24847 8.95298 7.7835 8.87352C9.32869 8.79336 10.8206 9.61293 11.5809 10.9614Z",
    fill: "#413E34"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8746 5.06898C6.86159 4.54267 5.42458 3.31589 4.7674 3.41128L4.65252 3.62734C5.15372 3.66851 6.41551 4.22644 6.57314 5.19087C6.57314 5.19087 6.87574 5.11492 6.8746 5.06898Z",
    fill: "#413E34",
    stroke: "#413E34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20597 5.06898C9.21898 4.54267 10.656 3.31589 11.3132 3.41128L11.428 3.62734C10.9268 3.66851 9.66505 4.22644 9.50742 5.19087C9.50742 5.19087 9.20483 5.11492 9.20597 5.06898Z",
    fill: "#413E34",
    stroke: "#413E34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackVn);
export default __webpack_public_path__ + "static/media/feedback-vn.a6dc9ab64ab0850b94fedb3602f28446.svg";
export { ForwardRef as ReactComponent };